'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';

export default function HeroSection() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    // 'bg-black' tetap ada sebagai base, 'grain-overlay' tetap dipertahankan sesuai permintaan
    <section className="relative w-full min-h-[100dvh] overflow-hidden bg-black grain-overlay">
      
      {/* Background Video Layer */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          // cinematic-entrance tetap dipertahankan
          className="absolute inset-0 w-full h-full object-cover cinematic-entrance"
        >
          <source 
            src="/assets/video/demo.mp4" 
            type="video/mp4" 
          />
          Your browser does not support the video tag.
        </video>

        {/* Overlay Gradasi agar teks terbaca - Tetap dipertahankan */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-transparent to-black/60 z-0" />
      </div>

      {/* Hero Content - z-10 memastikan teks di atas video */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24">
        
        {/* Kontainer teks */}
        <div className="max-w-4xl md:pl-16"> 
          
          {/* Label Jabodetabek */}
          <div
            className="flex items-center gap-3 mb-4 md:mb-6 opacity-0 slide-up-entrance"
            style={{ animationDelay: '0.8s' }}
          >
            <span className="h-px w-8 bg-accent" />
            <span className="text-xs font-mono uppercase tracking-widest text-white/80">
              Jabodetabek & Seluruh Indonesia
            </span>
          </div>

          <h1
            className="text-hero-xl font-extrabold text-white leading-[0.85] tracking-tighter opacity-0 slide-up-entrance"
            style={{ animationDelay: '1.0s' }}
          >
            <span className="block">INDO</span>
            <span className="block text-accent">CUTTING</span>
            <span className="block text-white/80 font-light italic">
              Laser
            </span>
          </h1>

          <p
            className="mt-6 md:mt-8 text-white/90 text-lg md:text-xl font-light max-w-2xl leading-relaxed opacity-0 slide-up-entrance"
            style={{ animationDelay: '1.2s' }}
          >
            Jasa laser cutting metal, CO2, ACP, dan CNC router dengan teknologi presisi tinggi
            untuk kebutuhan industri dan dekorasi.
          </p>

          <div
            className="flex flex-wrap gap-4 mt-8 md:mt-10 opacity-0 slide-up-entrance"
            style={{ animationDelay: '1.4s' }}
          >
            <a
              href="https://wa.me/628132282297?text=Halo%20IndoCuttingLaser%2C%20saya%20ingin%20konsultasi"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-green-500 hover:bg-green-400 text-white font-semibold text-sm transition-all duration-300 hover:-translate-y-1 shadow-green-glow"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              Konsultasi Gratis
            </a>
            <Link
              href="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300"
            >
              Tentang Kami
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                className="w-4 h-4"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-0 slide-up-entrance"
        style={{ animationDelay: '2.0s' }}
      >
        <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}